import { motion } from "framer-motion";
import { MessageCircle, UserCircle2 } from "lucide-react";
import { whatsappLink, WA, CONTACT } from "@/data/content";

export default function Fernando() {
  return (
    <section id="fernando" data-testid="fernando-section" className="relative py-24 lg:py-32">
      <div className="absolute inset-x-0 top-1/3 h-72 teal-glow pointer-events-none" />
      <div className="relative max-w-6xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-2"
          >
            {/* Placeholder ritratto — sostituire con foto reale di Fernando Padovano */}
            <div data-testid="fernando-photo" className="relative aspect-[4/5] rounded-3xl border border-white/10 bg-gradient-to-b from-[#0d1514] to-[#0b0b0b] overflow-hidden flex flex-col items-center justify-center">
              <UserCircle2 size={96} className="text-teal-light/40" strokeWidth={1} />
              <p className="mt-4 font-display text-lg text-white">Fernando Padovano</p>
              <p className="mt-1 text-xs text-slate-500 px-6 text-center">Spazio per la fotografia professionale</p>
              <div className="absolute inset-0 grain opacity-[0.05] pointer-events-none" />
            </div>
          </motion.div>

          <div className="lg:col-span-3">
            <span className="font-accent text-xs uppercase tracking-[0.3em] text-teal-light">Chi è Fernando</span>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white leading-tight">
              Chi seguirà la tua comunicazione
            </h2>

            <p className="mt-6 font-display text-2xl text-white">Fernando Padovano</p>
            <p className="text-sm text-teal-light">Strategia, idee e direzione creativa</p>

            <p className="mt-5 text-slate-300 leading-relaxed">
              Fernando segue direttamente ogni attività, partendo dall'analisi iniziale fino alla
              creazione dei contenuti. Si occupa dello studio del settore, della strategia, dei
              format, delle idee, degli script e del rapporto con il cliente.
            </p>
            <p className="mt-4 text-slate-300 leading-relaxed">
              Il suo obiettivo è rendere semplice e naturale la comunicazione anche per chi non è
              abituato a parlare davanti alla telecamera.
            </p>

            <p className="mt-6 text-lg text-white">
              Non devi diventare un attore.{" "}
              <span className="text-teal-light">Devi solamente raccontare bene ciò che sai già fare.</span>
            </p>

            <a
              data-testid="fernando-cta"
              href={whatsappLink(WA.fernando)}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-teal-light px-7 py-3.5 text-sm font-semibold text-[#050505] hover:bg-white transition-colors"
            >
              <MessageCircle size={18} /> Parla direttamente con Fernando
            </a>

            <p className="mt-6 text-sm text-slate-500">
              Studio: {CONTACT.addressLine}, {CONTACT.city}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
